module.exports = __webpack_public_path__ + "static/media/wedding.4aedb050.jpg";